import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Event } from '../../models';
import { RouterLink } from '@angular/router';
import { AlertComponent } from 'src/app/standalone/components/alert/alert.component';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { NgClass } from '@angular/common';
import { IconComponent } from '@teamfoster/sdk/icon';
import { EventDateTimePipe } from '../../pipes/event-date-time.pipe';

@Component({
  selector: 'app-event-practical-info',
  imports: [RouterLink, EventDatePipe, AlertComponent, FromDictionaryPipe, NgClass, IconComponent, EventDateTimePipe],
  templateUrl: './event-practical-info.component.html',
  styleUrl: './event-practical-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventPracticalInfoComponent {
  event = input.required<Event>();
  showOnlyImportantInfo = input<boolean>(false); // For short texts, dont repeat base info

  hasRecurrencePattern = computed(() => (this.event().eventDates?.length || 0) > 1);

  nextDates = computed(() => {
    return (
      this.event()
        .eventDates?.filter(a => a != this.event().startDate)
        .slice(0, 3) || []
    );
  });

  hasMoreDates = computed(() => {
    const dates = this.event().eventDates?.filter(a => a != this.event().startDate);
    if (!dates) {
      return false;
    }
    return dates.length > 3;
  });

  hasAlert = computed(() => this.event().alert?.text || this.event().alert?.title);
}
